export const next = {
  methods: {
    next(question, value, type) {
      // console.log('next', question, value, type)
      if (typeof value !== 'undefined') {
        this.$store.dispatch('changeQuizValue', { question, value, type })
      }
      if (type !== 'multi') {
        this.$store.dispatch('advanceTimeline')
        // eslint-disable-next-line
      }
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'OCS Engagement',
          eventAction: 'advance',
          eventLabel: 'Advance Quiz Timeline | ' + question,
        });
      }
    },
  },
};
